
import { defineComponent, ref, inject, computed, provide } from "vue"

//components
import ModalNominal from "@/components/modals/general/ModalNominal.vue"
import MixedWidget1 from "@/components/widgets/mixed/Widget1.vue";
import MixedWidget14 from "@/components/widgets/mixed/Widget14.vue";

//icons
import { Search, ArrowLeft } from '@element-plus/icons-vue'

//services
import eventService from "@/core/services/EventService";
import sportService from "@/core/services/SportService";
import { errManager, mbtoa } from "@/core/config/Tools";

import axios from "axios";
import moment from 'moment';
moment.locale("es");

export default defineComponent({
    name: "ModalSport",
    components: {MixedWidget1, MixedWidget14, ModalNominal},
    props:{
        evento: {
            type: Object,
            required: true,
            default: {}
        },
        sport: {
            type: Object,
            required: true,
            default: {}
        },
        listSports: {
            type: null,
            required: true,
            default: []
        },
        listStatus: {
            type: null,
            required: true,
            default: []
        }
    },
    
    setup(props) {

        const dialogSport = inject<any>('dialogSport');
        const dialogNominal = ref(false)
        const listInstitutions = ref<any>([])
        const listRTRegister = ref<any>([])
        const listRCheckDoc = ref<any>([])
        const listRGender = ref<any>([])
        const idsport = ref()
        const rowClub = ref({})
        const idcheckdoc = ref<any>([])
        const sportDetails = ref<any>({})
        const total = ref(0)

        //provides shared data
        provide("dialogNominal", dialogNominal)

        //loaders
        const loader = ref(false)
        const loaderTable = ref(false)

        //search
        const searchClub = ref("")

        //methods
        const opened = () => {
            idsport.value = props.sport.idsport
            setStatus()
            getListClubs()
            Closure()
            getSummary()
        }

        const onBack = () => {
            dialogSport.value = false
        }

        const setStatus = () => {
            if(idcheckdoc.value.length==0){
                idcheckdoc.value.length = 0
                props.listStatus.forEach((element: any) => {
                    idcheckdoc.value.push(element.id)
                });
            }
        }

        const changeSport = () => {
            getListClubs();
            Closure();
            getSummary();
        }

        const getListClubs = async () => {
            loaderTable.value = true
            listInstitutions.value.length = 0 
            await eventService.getClubs({
                idevent: props.evento?.idevent,
                idsport: idsport.value,
                checkdoc: idcheckdoc.value
            })
            .then ( (res) => {
                loaderTable.value = false
                listInstitutions.value = res.data
            }).catch ( ({ response }) => {
                loaderTable.value = false
                errManager(response)
            })
        }

        const filteredClubs = computed(() => {
            return listInstitutions.value.filter(
                (item) =>
                (item.abrev && item.abrev.toLowerCase().includes(searchClub.value.toLowerCase())) || 
                item.business.includes(searchClub.value.toLowerCase())
            );
        });

        const Closure = async () => {
            await sportService.getClosure({idevent: props.evento?.idevent, idsport:idsport.value})
            .then ( (res) => {
                sportDetails.value = res.data
            }).catch ( ({ response }) => {
                errManager(response)
            })
        }

        const getSummary = async () => {
            listRTRegister.value.length = 0
            listRCheckDoc.value.length = 0
            total.value = 0
            listRGender.value.length = 0 
            await eventService.summary({idevent: props.evento?.idevent, idsport:idsport.value, checkdoc: idcheckdoc.value})
            .then( (res) => {
                listRTRegister.value = res.data.rtregister
                listRCheckDoc.value = res.data.rcheckdoc
                listRGender.value = res.data.rgender
                listRGender.value.forEach(element => {
                    total.value += parseInt(element.quantity)
                });
            }).catch ( ({ response }) => {
                errManager(response)
            })
        }

        //open dialog nominal
        const openDialogNominal = (row) => {
            rowClub.value = row
            dialogNominal.value = true
        }

        //Descargar reportes Excel
        const DownloadXLSXPDF = (ext, target, payload) => {
            loader.value = true
            //this.$Progress.start();
            loaderTable.value = true
            let params = new URLSearchParams(payload);
            axios({
                url: process.env.VUE_APP_API_URL + `/${ext}/${target}?${params}`,
                method: 'GET',
                responseType: 'blob',
            }).then((response) => {
                if(ext == 'zip')
                    var fileBlob = new Blob([response.data], { type: 'application/zip' });
                else 
                    var fileBlob = new Blob([response.data]);

                var fileURL = window.URL.createObjectURL(fileBlob);
                var fURL = document.createElement('a');
                var nameFile = moment().format() + "." +ext

                fURL.href = fileURL;
                fURL.setAttribute('download', nameFile);
                document.body.appendChild(fURL);
                loaderTable.value = false
                //this.$Progress.finish();
                fURL.click();
                loader.value = false
            }).catch( (err) => {
                loader.value = false
                loaderTable.value = false
                errManager(err)
            })
        }
        
        const oClosed = () =>{
            listInstitutions.value.length = 0;
            listRTRegister.value.length = 0;
            listRCheckDoc.value.length = 0;
            listRGender.value.length = 0;
        }

        return {

            //variables
            dialogSport,
            dialogNominal,
            idsport,
            rowClub,
            idcheckdoc,
            searchClub,
            sportDetails,

            //icons
            Search,
            total,
            ArrowLeft,

            //list
            listInstitutions,
            listRTRegister,
            listRCheckDoc,
            listRGender,

            //loaders
            loaderTable,
            loader,

            //methods
            onBack,
            opened,
            oClosed,
            changeSport,
            getListClubs,
            filteredClubs,
            Closure,
            getSummary,
            openDialogNominal,
            DownloadXLSXPDF,
            mbtoa
        }

    },
})
